import React from 'react';
import { IOldIconProps } from './type';

const DeliveryOutline: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 7.57813C1.5 6.15427 2.65427 5 4.07812 5H17.9062C19.3301 5 20.4844 6.15427 20.4844 7.57812V9.26136H22.9973C23.9879 9.26136 24.8908 9.82891 25.3204 10.7215L27.3745 14.9897C27.5697 15.3954 27.9802 15.6534 28.4304 15.6534H30.3281H31.0312V16.3565V22.5781C31.0312 24.002 29.877 25.1562 28.4531 25.1562H28.1484C27.8227 26.761 26.404 27.9688 24.7031 27.9688C23.0023 27.9688 21.5836 26.761 21.2578 25.1562H19.7812H12.2109C11.8852 26.761 10.4665 27.9688 8.76562 27.9688C7.0648 27.9688 5.64606 26.761 5.32033 25.1562H4.07812C2.65427 25.1562 1.5 24.002 1.5 22.5781V7.57813ZM21.2578 23.75C21.5836 22.1453 23.0023 20.9375 24.7031 20.9375C26.404 20.9375 27.8227 22.1453 28.1484 23.75H28.4531C29.1003 23.75 29.625 23.2253 29.625 22.5781V17.0597H28.4304H20.4844V23.75H21.2578ZM19.0781 23.75H12.2109C11.8852 22.1453 10.4665 20.9375 8.76562 20.9375C7.0648 20.9375 5.64606 22.1453 5.32033 23.75H4.07812C3.43092 23.75 2.90625 23.2253 2.90625 22.5781V7.57813C2.90625 6.93092 3.43092 6.40625 4.07812 6.40625H17.9062C18.5535 6.40625 19.0781 6.93092 19.0781 7.57812V9.96449V16.3565V23.75ZM20.4844 15.6534H26.134C26.1249 15.6356 26.116 15.6176 26.1073 15.5995L24.0533 11.3313C23.858 10.9256 23.4476 10.6676 22.9973 10.6676H20.4844V15.6534ZM8.76562 22.3438C7.60065 22.3438 6.65625 23.2881 6.65625 24.4531C6.65625 25.6181 7.60065 26.5625 8.76562 26.5625C9.9306 26.5625 10.875 25.6181 10.875 24.4531C10.875 23.2881 9.9306 22.3438 8.76562 22.3438ZM22.5938 24.4531C22.5938 23.2881 23.5381 22.3438 24.7031 22.3438C25.8681 22.3438 26.8125 23.2881 26.8125 24.4531C26.8125 25.6181 25.8681 26.5625 24.7031 26.5625C23.5381 26.5625 22.5938 25.6181 22.5938 24.4531Z"
        fill={color}
      />
    </svg>
  );
};

export default DeliveryOutline;
